import { Drawer, Layout, theme as antTheme } from "antd";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import { MdAccountCircle } from "react-icons/md";
import { getSecondPathCode } from "../../../utils/getPathCode";
import MenuComponent from "./Menu";
import { setUserItem } from "../../../redux/slices/user-slice";
import { getGlobalState } from "../../../utils/getGlobalState";
import HeaderAdmin from "./Header";
import BodyAdmin from "./Body";
import { FaFileInvoice, FaHistory } from "react-icons/fa";

const { Sider, Content } = Layout;
const WIDTH = 992;

const LayoutAdmin = () => {
  const location = useLocation();
  const [openKey, setOpenkey] = useState();
  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const { device, collapsed } = useSelector((state) => state.user);
  const token = antTheme.useToken();

  const isMobile = device === "MOBILE";
  const dispatch = useDispatch();

  const { userLogin } = useSelector((state) => state.user);

  let MenuList = [
    {
      key: "request-einvoice-issuance",
      icon: <FaFileInvoice size={22} />,
      label: "Yêu cầu xuất",
    },
  ];

  if (userLogin.role === "admin") {
    MenuList.push(
      {
        key: "accounts",
        icon: <MdAccountCircle size={24} />,
        label: "Tài khoản",
      },
      {
        key: "logs",
        icon: <FaHistory size={22} />,
        label: "Logs",
      }
    );
  }

  useEffect(() => {
    const code = getSecondPathCode(location.pathname);

    setOpenkey(code);
    setSelectedKey(code);
  }, [location.pathname]);

  const toggle = () => {
    dispatch(
      setUserItem({
        collapsed: !collapsed,
      })
    );
  };

  useEffect(() => {
    window.onresize = () => {
      const { device } = getGlobalState();
      const rect = document.body.getBoundingClientRect();
      const needCollapse = rect.width < WIDTH;

      dispatch(
        setUserItem({
          device,
          collapsed: needCollapse,
        })
      );
    };
  }, [dispatch]);

  return (
    <Layout className="layout-page" style={{ height: "100%" }}>
      <HeaderAdmin collapsed={collapsed} toggle={toggle} />
      <Layout>
        {!isMobile ? (
          <Sider
            className="layout-page-sider"
            trigger={null}
            collapsible
            style={{ backgroundColor: token.token.colorBgContainer }}
            collapsedWidth={isMobile ? 0 : 80}
            collapsed={collapsed}
            breakpoint="md"
          >
            <MenuComponent
              menuList={MenuList}
              openKey={openKey}
              onChangeOpenKey={(k) => setOpenkey(k)}
              selectedKey={selectedKey}
              onChangeSelectedKey={(k) => setSelectedKey(k)}
            />
          </Sider>
        ) : (
          <Drawer
            width="200"
            placement="left"
            closable={false}
            onClose={toggle}
            open={!collapsed}
            styles={{ body: { padding: 0, height: "100%" } }}
          >
            <MenuComponent
              menuList={MenuList}
              openKey={openKey}
              onChangeOpenKey={(k) => setOpenkey(k)}
              selectedKey={selectedKey}
              onChangeSelectedKey={(k) => setSelectedKey(k)}
            />
          </Drawer>
        )}
        <Content className="layout-page-content">
          {/* <TagsView /> */}
          <Suspense fallback={null}>
            <BodyAdmin>
              <Outlet />
            </BodyAdmin>
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutAdmin;
